export const ITEMS_PER_PAGE = 10; // this value must keep same as the one defined in backend!

export const QQ_GROUP_NUM = '1080776136';
export const CONTACT_EMAIL = 'kefu@scairi.com.cn';
